module.exports = __webpack_public_path__ + "img/support6.49fbb803.jpg";